exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tinymce-container[data-v-0177f75c] {\n  position: relative;\n  line-height: normal;\n}\n.tinymce-container[data-v-0177f75c] .mce-fullscreen {\n  z-index: 10000;\n}\n.tinymce-textarea[data-v-0177f75c] {\n  visibility: hidden;\n  z-index: -1;\n}\n.editor-custom-btn-container[data-v-0177f75c] {\n  position: absolute;\n  right: 4px;\n  top: 4px;\n  /*z-index: 2005;*/\n}\n.fullscreen .editor-custom-btn-container[data-v-0177f75c] {\n  z-index: 10000;\n  position: fixed;\n}\n.editor-upload-btn[data-v-0177f75c] {\n  display: inline-block;\n}\n", ""]);

// exports
